<form [formGroup]="formGroup">
  <input type="text"
    minlength="7"
    [formControl]="ctrlFullTag"
    [attr.placeholder]="placeholder"
    [attr.disabled]="disabled ? disabled : null"
    [aaAutocomplete]="tagac"
    class="ac-input" />
    <aa-autocomplete #tagac="autoComplete" [width]="250">
      <ng-template aaAutocompleteContent>
        @if ((tags| autocompleteFilter : ctrlFullTag.value : 'fullTagName'); as result) {
          @for (tag of result; track tag) {
            <aa-autocomplete-option
              [value]="tag">
              <div class="tag-search-item pointer"
                (click)="onClick(tag)"
                [style.color]="tag.fgColor"
                [style.backgroundColor]="tag.bgColor">
                {{ tag.fullTagName }}
              </div>
            </aa-autocomplete-option>
          }
          @if (result.length) {
            <aa-autocomplete-option>
              <div class="tag-search-item infos">
                Click to select
              </div>
            </aa-autocomplete-option>
          }
          @if (!result.length) {
            <aa-autocomplete-option>
              <div class="tag-search-item infos">
                No more tag...
              </div>
            </aa-autocomplete-option>
          }
        }
      </ng-template>
    </aa-autocomplete>
  </form>
